import * as yup from 'yup';

export const userLoginSchema = yup.object({
  username: yup.string().required('Username es requerido').email('Correo electrónico inválido'),
  password: yup.string().required('Contraseña es requerida')
  
});